// Дизайн-система проекта: база martyrs (слои) + JIT-утилиты + тема traffers.
// Всё внутри @/design-system/index.js — единая точка подключения.
import '@/design-system/index.js';

import { createUniversalApp } from '@ozdao/martyrs/modules/core/client';

import { getConfig } from '@/configs/global.config.js';
import { getRouter } from '@/router/index.js';
import { getStore } from '@/store/index.js';
import { getLocales } from '@/localization/index.js';
import chatDrawerPlugin from '@/plugins/chat-drawer.plugin.js';

const appPromise = createUniversalApp({
  getConfig,
  getRouter,
  getLocales,
  getStore,
  // afterInitialize стреляет в конце initialize() в core.app.js — на этот момент
  // app уже создан и core-плагины (alert, datePicker) подключены. Подключаем
  // сюда наш chat-drawer тем же путём, что martyrs подключает свои попапы.
  getHooks: {
    afterInitialize: ({ app }) => {
      app.use(chatDrawerPlugin);
    },
  },
});

export async function _renderApp({ url, cookies, languages, ssrContext }) {
  const { renderApp } = await appPromise;

  return renderApp({ url, cookies, languages, ssrContext });
}
